import { type ApiResponse, HTTPMethod, request } from '../global/api/legacyApi'
import { getLiveId, getPresenterToken, getRole } from '../global/blocs/roomInfo'
import queryClient from '../queryClient'

type RealtimeInfoDTO = {
  live_id: number // 8809238
  public_realtime_url: string // '/8730c56415181a57923e93a1a963e44dfd0c6e48/events'
  realtime_channel: string // '/b13022edad7bc016b0d3ed5f4c628975cfd10cc2/events'
  realtime_channel_site: string // '/8730c56415181a57923e93a1a963e44dfd0c6e48'
  realtime_url: string // 'https://realtime.dev.23video.com/faye'
  timezone_offset: number // 1
}

type RealTimeInfo = {
  realtimeDomain: string
  privateChannelId: string
  publicChannelId: string
}

const mapDTOtoRealtimeInto = (
  dto: RealtimeInfoDTO,
  isAudience: boolean
): RealTimeInfo => {
  const privateChannelId = isAudience
    ? ''
    : `/${dto.realtime_channel.split('/')[1]}`

  return {
    realtimeDomain: dto.realtime_url,
    publicChannelId: dto.realtime_channel_site,
    privateChannelId,
  }
}

type AudienceRealTimeInfoQueryParams = {
  token: string
}

type ProducerOrPresenterRealtTimeInfoQueryParams = {
  presenter_token?: string
  channel_type?: 'public'
}

type RealtimeInfoQueryParams = {
  live_id: number
} & (
  | AudienceRealTimeInfoQueryParams
  | ProducerOrPresenterRealtTimeInfoQueryParams
)

const realtimeInfoQuery = {
  queryKey: ['REALTIME_INFO'],
  queryFn: async () => {
    const liveId = getLiveId()
    const isAudience = getRole() === 'audience'
    const presenterToken = getPresenterToken()

    let data: RealtimeInfoQueryParams = {
      live_id: liveId,
    }

    if (isAudience) {
      data = {
        ...data,
        token: window.LIVE_TOKEN,
        channel_type: 'public',
      }
    } else {
      data = {
        ...data,
        presenter_token: presenterToken,
      }
    }

    const response = await request<ApiResponse<RealtimeInfoDTO>>({
      url: '/api/2/live/realtime/',
      method: HTTPMethod.GET,
      data,
    })
    return mapDTOtoRealtimeInto(response.data, isAudience)
  },
  cacheTime: Infinity,
  staleTime: Infinity,
}

const getRealtimeInfo = () => queryClient.fetchQuery(realtimeInfoQuery)

export { getRealtimeInfo }
